export const convertToUtc = (dateString: string): string => {
    if (!dateString) {
        throw new Error("date string is required.");
    }
    const [year, month, day] = dateString.split("-").map(Number);
    const localMidnight = new Date(year, month - 1, day, 0, 1, 0, 0);
    return localMidnight.toISOString();
};